import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { DateWiseSearch } from './DateWiseSearch'
export const MissingPeople=() =>{
  
  return (
    <>
    <MainDiv>
    {/* <MainContent/>         */}
    <DateWiseSearch />
    {/* <DateWiseSearchWithPagination /> */}
   </MainDiv> 
    </>
    
  )
}
